import "./App.css";
import DataAnalyzer from "./DataAnalyzer";

function App() {
  return <DataAnalyzer />;
}

export default App;
